// App.js
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
// Styles
import "./App.css";
import "./move.css";
// Components
import { Login } from "./components/login";
import { MainDashboard } from "./components/mainDashboard";
import { MainDashboardClient } from "./components/mainDashboardClient";
import { MainRutine } from "./components/mainRutine";
import { MainUsers } from "./components/mainUsers";
import { MainCalendar } from "./components/mainCalendar";
import { MainDepartments } from "./components/mainDepartments";
import { MainReports } from "./components/mainReports";
import { MainNotifications } from "./components/mainNotifications";
import { NotFound } from "./components/notFound";
import { DetailRutine } from "./components/rutines/detailRutine";
import { ResetPassword } from "./components/screens/auth/ResetPassword/ResetPassword";
import { ForgotPassword } from "./components/screens/auth/ForgotPassword/ForgotPassword";
import { ListVideos } from "./components/videos/listVideos";
import { MainReportProblem } from "./components/mainReportProblem";
import { MainTickets } from "./components/mainTickets";
// Contexts
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import MoveApp from "./components/moveclient/moveApp";

const ProtectedRoute = ({ element: Component, requiredPermission }) => {
  const { permissions, isLoading } = useAuth();

  if (isLoading) {
    // Aquí podrías mostrar un indicador de carga
    return <div>Loading...</div>;
  }

  return permissions.includes(requiredPermission) ? (
    <Component />
  ) : (
    <Navigate to="/" />
  );
};

function App() {
  return (
    <HashRouter>
      <NotificationProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:email" element={<ResetPassword />} />
            <Route
              path="/main-dashboard"
              element={
                <ProtectedRoute
                  element={MainDashboard}
                  requiredPermission="Super User"
                />
              }
            />
            <Route
              path="/dashboard-client"
              element={
                <ProtectedRoute
                  element={MainDashboardClient}
                  requiredPermission="Read Client"
                />
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute
                  element={MainUsers}
                  requiredPermission="Read User"
                />
              }
            />
            <Route
              path="/calendar"
              element={
                <ProtectedRoute
                  element={MainCalendar}
                  requiredPermission="Read Calendar"
                />
              }
            />
            <Route
              path="/departments"
              element={
                <ProtectedRoute
                  element={MainDepartments}
                  requiredPermission="Read Department"
                />
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute
                  element={MainReports}
                  requiredPermission="Reports"
                />
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute
                  element={MainNotifications}
                  requiredPermission="Read Notification"
                />
              }
            />
            <Route
              path="/rutines"
              element={
                <ProtectedRoute
                  element={MainRutine}
                  requiredPermission="Read Routine"
                />
              }
            />
            <Route
              path="/rutine/:id"
              element={
                <ProtectedRoute
                  element={DetailRutine}
                  requiredPermission="Read Routine"
                />
              }
            />
            <Route
              path="/videos"
              element={
                <ProtectedRoute
                  element={ListVideos}
                  requiredPermission="Read Video"
                />
              }
            />
            <Route path="/move" element={<MoveApp />} />
            <Route path="/report-problem" element={<MainReportProblem />} />
            <Route
              path="/tickets"
              element={
                <ProtectedRoute
                  element={MainTickets}
                  requiredPermission="Reports"
                />
              }
            />
            {/* Catch-all route for 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </NotificationProvider>
    </HashRouter>
  );
}

export default App;
